import { handleActions, combineActions } from 'redux-actions';
import actions from '../actions';

const { reset, price, points, discount, customPrice, submit } = actions.order;

const defaultState = {
  submitting: false,
  price: 0,
  points: 0,
  discount: {},
  customPrice: 0,
  customPriceEnabled: false,
};

const order = handleActions(
  {
    [combineActions(price.edit, customPrice.edit, discount.edit)]: (
      state,
      { payload }
    ) => ({ ...state, ...payload }),
    [reset]: state => defaultState,
    [submit.enable]: state => ({ ...state, submitting: true }),
    [submit.disable]: state => ({ ...state, submitting: false }),
    [customPrice.toggle]: state => ({
      ...state,
      customPriceEnabled: !state.customPriceEnabled,
    }),
    [points.use]: (state, { payload }) => ({ ...state, points: payload }),
    [points.reset]: state => ({ ...state, points: 0 }),
  },
  defaultState
);

export default order;



// WEBPACK FOOTER //
// ./src/reducers/order.js